import BaseDataObject from './BaseDataObject';
import PointReduction from './PointReduction';

export default class PointReductionSet extends BaseDataObject {
  constructor() {
    super(...arguments);
    if (this.getNumberOfPointReductions() === 0) {
      this.addPointReduction();
      this.validate();
    }
  }

  getNumberOfPointReductions() {
    return this.getNumberOf('pointReductions');
  }

  getPointReduction(index) {
    return this.getObject('pointReductions', PointReduction, index);
  }

  getPointReductions() {
    return this.getObjects('pointReductions', PointReduction);
  }

  hasAnyFactorsOnPointSums() {
    const pointReductions = this.getPointReductions();
    return (
      Array.isArray(pointReductions) &&
      pointReductions.some(pointReduction =>
        pointReduction
          .getFactorsOnPointSums()
          .some(factorOnPointSum => !factorOnPointSum.isEmpty()),
      )
    );
  }

  addPointReduction(data) {
    this.invalidate();
    return this.addObject('pointReductions', PointReduction, data);
  }

  deletePointReduction(index) {
    this.invalidate();
    this.deleteObject('pointReductions', index);

    if (this.getNumberOfPointReductions() === 0) {
      this.addPointReduction();
    }
  }

  getMaxNumberOfPointReductions() {
    return 50;
  }
}
